import React from 'react';

import TranslatedOption from 'components/layout/forms/TranslatedOption';

const getOptions = (
  elements: string[],
  translationFile: string,
  section: string
): JSX.Element[] =>
  elements.map((element) => (
    <TranslatedOption
      element={element}
      key={element}
      section={section}
      translationFile={translationFile}
    />
  ));

export default getOptions;
